import { ThemeContext, ThemeOptions } from '@ifit/themes/ThemeContext';
import uniqBy from 'lodash.uniqby';
import React, { useContext, useMemo } from 'react';
import { useEntitiesRowQuery } from '../../client/query/entities';
import { getFilters } from '../../helpers/quickFiltersStore';
import { translateFilter } from '../../i18n/filter-options';
import { getSearchState } from '../../views/search/state/search-state';
import {
  timeRangesFiltersMap,
  equipmentFiltersMap,
  equipmentOptionsMap,
  vaultEquipmentFiltersMap,
} from './filters';
import './index.scss';

const numberOfFiltersToShow = 10;

interface IProps {
  equipmentType: string;
}

const CategoryLink: React.FC<IProps> = ({ equipmentType }) => {
  const { theme } = useContext(ThemeContext);
  const { data: categories } = useEntitiesRowQuery({
    groupBy: 'category',
    perPage: 0,
  });

  function translateCategory(filterDisplay: string): string {
    let result = null;
    categories?.length &&
      categories.forEach(category => {
        if (category.title === filterDisplay) {
          result = category['translatedTitle'];
        }
      });
    return result;
  }

  const filters = useMemo(() => {
    const isVaultTheme = theme === ThemeOptions.vault;
    const timeRangesFilter = timeRangesFiltersMap[equipmentType];
    const vaultEquipmentFilter = vaultEquipmentFiltersMap[equipmentType];
    let equipmentFilter = equipmentFiltersMap[equipmentType];
    let defaultFilters;

    if (!isVaultTheme) {
      defaultFilters = equipmentOptionsMap[timeRangesFilter]
        ? equipmentOptionsMap[timeRangesFilter].concat(
            equipmentOptionsMap[equipmentFilter],
          )
        : equipmentOptionsMap[equipmentFilter] || [];
    } else {
      defaultFilters = equipmentOptionsMap[timeRangesFilter]
        ? equipmentOptionsMap[timeRangesFilter].concat(
            equipmentOptionsMap[vaultEquipmentFilter],
          )
        : equipmentOptionsMap[vaultEquipmentFilter] ||
          equipmentOptionsMap[equipmentFilter] ||
          [];
      equipmentFilter = vaultEquipmentFilter;
    }

    return uniqBy(
      [
        ...getFilters(),
        ...defaultFilters.map(x => {
          return x === '0-1199'
            ? {
                type: timeRangesFilter,
                filter: x,
                display: 'Less than 20 min',
              }
            : {
                type: equipmentFilter,
                filter: x,
                display: x,
              };
        }),
      ],
      'filter',
    ).slice(0, numberOfFiltersToShow);
  }, [equipmentType, theme]);

  const onClicks = useMemo(() => {
    return filters.map(filter => () => {
      getSearchState().resetSearchState();
      return getSearchState().changeFilter(filter.type, filter.filter, true);
    });
  }, [filters]);

  if (filters.length === 0) {
    return null;
  }

  return (
    <div className="scroll-categories">
      <div className="contain-categories">
        {filters.map((filter, index) => (
          <div
            data-testid={'action-button'}
            key={filter.type + filter.filter}
            onClick={onClicks[index]}
            className="class-link"
          >
            {translateCategory(filter.display) || translateFilter(filter)}
          </div>
        ))}
      </div>
    </div>
  );
};

export default CategoryLink;
